import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-product-insured-building',
  templateUrl: './product-insured-building.component.html',
  styleUrls: ['./product-insured-building.component.scss']
})
export class ProductInsuredBuildingComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
